import { useTranslation } from 'react-i18next';
import { SUPPORTED_LNGS, type Lang } from '../i18n';
import './LanguageSwitcher.css';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const active = (i18n.language.split('-')[0] || 'cs') as Lang;

  return (
    <div className="lang-switcher" role="group" aria-label="Language">
      {SUPPORTED_LNGS.map((lng) => (
        <button
          key={lng}
          type="button"
          className={`lang-switcher__btn ${active === lng ? 'is-active' : ''}`}
          onClick={() => void i18n.changeLanguage(lng)}
          aria-pressed={active === lng}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
